export const cardTitleStyle = {
    fontSize: 13,
    position: 'absolute',
    top: '-10px',
    background: 'white',
    padding: '0 0.2rem',
};

export const cardStyle = {
    height: '4rem',
    display: 'flex',
    alignItems: 'center',
};

export const cardContentStyle = {
    fontSize: 11,
    margin: 0,
    wordBreak: 'break-all',
};

export const headContainerStyle = {
    display: 'flex',
    alignItems: 'center',
};

export const logoStyle = {
    height: '1rem',
    objectFit: 'contain',
};

export const patientTabTitleStyle = {
    display: 'flex',
    alignItems: 'center',
    gap: '15px',
};
